import React from 'react';
import Feature from './feature';
import i18n from 'i18next';
import config from 'config/config';

const FeatureList = () => {
  const features = [
    {
      id: 'question',
      iconPath: `${config.cdn.static}img/home/icon-question.svg`,
      name: i18n.t('Ask a question'),
      description: i18n.t('Get answers from those who understand'),
    },
    {
      id: 'community',
      iconPath: `${config.cdn.static}img/home/icon-community.svg`,
      name: i18n.t('Join a community'),
      description: i18n.t('Access support and advice 24/7'),
    },
    {
      id: 'friends',
      iconPath: `${config.cdn.static}img/home/icon-friends.svg`,
      name: i18n.t('Find new friends'),
      description: i18n.t('Find others like you, near to you'),
    },
    {
      id: 'quiz',
      iconPath: `${config.cdn.static}img/home/icon-quiz.svg`,
      name: i18n.t('Take a health needs quiz'),
      description: i18n.t('Recognise your unmet health needs'),
    },
    {
      id: 'program',
      iconPath: `${config.cdn.static}img/home/icon-program.svg`,
      name: i18n.t('Enroll in a program'),
      description: i18n.t('Learn more about the topics that are relevant to you'),
    },
    {
      id: 'research',
      iconPath: `${config.cdn.static}img/home/icon-research.svg`,
      name: i18n.t('Take part in research'),
      description: i18n.t('Opt in to find out about opportunities'),
    },
  ];

  return (
    <div className="home__features">
      {features.map(feature => (
        <Feature
          key={`feature-${feature.id}`}
          {...feature}
        />
      ))}
    </div>
  );
};

export default FeatureList;



// WEBPACK FOOTER //
// ./src/modules/home/components/featureList.js